import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses, WithClientOptions, WithDialogStackContext, DialogProps } from '@paintscout/ui'
import { createStyles, withStyles } from '@material-ui/core/styles'
import type { QuoteDocument } from 'paintscout'
import {
  Button,
  withClientOptions,
  withDialogStackContext,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@paintscout/ui'
import { getObjectLabels } from '@paintscout/util/builder'
import React from 'react'
import EditQuoteDetailsForm from './EditQuoteDetailsForm'

export interface EditQuoteDetailsDialogProps extends DialogProps, WithClientOptions, WithDialogStackContext {
  classes?: DialogProps['classes'] & StyleClasses<typeof styles>
  quote: QuoteDocument
  onConfirm?: (quote: QuoteDocument) => void
  onCancel?: () => void
}

export interface EditQuoteDetailsDialogState {
  quote: QuoteDocument
}

const styles = (_theme: Theme) => {
  return createStyles({
    root: {}
  })
}

class EditQuoteDetailsDialog extends React.PureComponent<EditQuoteDetailsDialogProps, EditQuoteDetailsDialogState> {
  constructor(props: EditQuoteDetailsDialogProps) {
    super(props)

    const { quote } = this.props

    this.state = {
      quote: { ...quote }
    }
  }

  public render() {
    const {
      quote,
      classes,
      clientOptions,
      dialogStackContext: _dialogStackContext,
      onConfirm: _onConfirm,
      ...otherProps
    } = this.props
    const { options } = clientOptions

    const leftButton = (
      <Button onClick={this.props.onCancel} variant="textNoPadding">
        Cancel
      </Button>
    )

    const objectLabels = getObjectLabels({ options })

    return (
      <Dialog className={classes.root} {...otherProps} fullWidth={true} maxWidth={'md'}>
        <DialogTitle>{`Edit ${objectLabels.quote.value} Details`}</DialogTitle>
        <DialogContent>
          <EditQuoteDetailsForm quote={quote} options={options} onChange={this.handleChange} />
        </DialogContent>
        <DialogActions showBorder={true} leftButton={leftButton}>
          <Button onClick={this.handleConfirm} variant={'contained'}>
            Done
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  public handleChange = (updatedQuote: QuoteDocument) => {
    this.setState({ quote: updatedQuote })
  }

  public handleConfirm = (_event: any) => {
    if (this.props.onConfirm) {
      this.props.onConfirm(this.state.quote)
    }
  }
}

export default withStyles(styles)(withClientOptions(withDialogStackContext(EditQuoteDetailsDialog)))
